export var FErrorPageTranslationsLocaleEnum;
(function (FErrorPageTranslationsLocaleEnum) {
    FErrorPageTranslationsLocaleEnum["en"] = "en";
    FErrorPageTranslationsLocaleEnum["nl"] = "nl";
    FErrorPageTranslationsLocaleEnum["fr"] = "fr";
    FErrorPageTranslationsLocaleEnum["de"] = "de";
    FErrorPageTranslationsLocaleEnum["it"] = "it";
    FErrorPageTranslationsLocaleEnum["es"] = "es";
})(FErrorPageTranslationsLocaleEnum || (FErrorPageTranslationsLocaleEnum = {}));
export const ERROR_PAGE_TRANSLATIONS = {
    en: {
        title: 'Oops! We seem to have hit a bit of a snag...',
        description: 'Unfortunately, the page you were looking for could not be found or has encountered an unforeseen difficulty. Please try reloading the page. If the problem persists, please contact us.'
    },
    nl: {
        title: 'Oeps! We lijken een klein probleempje te hebben...',
        description: 'Helaas kon de pagina die u zocht niet worden gevonden of is er een onvoorzien probleem opgetreden. Probeer de pagina opnieuw te laden. Als het probleem zich blijft voordoen, neem dan contact met ons op.'
    },
    fr: {
        title: 'Oups ! Il semblerait que nous rencontrions un petit pépin…',
        description: 'La page que vous cherchiez est malheureusement introuvable ou a rencontré une difficulté imprévue. Veuillez tenter de recharger la page. Si le problème persiste, contactez-nous.'
    },
    de: {
        title: 'Huch! Wir scheinen auf ein kleines Problem gestoßen zu sein...',
        description: 'Leider konnte die von Ihnen gesuchte Seite nicht gefunden werden oder es ist ein unvorhergesehenes Problem aufgetreten. Bitte versuchen Sie, die Seite neu zu laden. Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte.'
    },
    it: {
        title: 'Ops! Sembra che ci sia stato un piccolo intoppo...',
        description: 'Purtroppo la pagina che stavate cercando non è stata trovata o ha incontrato un problema imprevisto. Provi a ricaricare la pagina. Se il problema persiste, contattateci.'
    },
    es: {
        title: '¡Uy! Parece que nos hemos topado con un pequeño obstáculo...',
        description: 'Lamentablemente, la página que buscaba no se ha podido encontrar o ha encontrado una dificultad imprevista. Por favor, intente recargar la página. Si el problema persiste, póngase en contacto con nosotros.'
    }
};
